const PROTOCOL = 'http'
const HOSTNAME = 'localhost'
const PORT = '3001'
const URL_PATH = 'https://vera-backend.onrender.com'

// Uncomment this when you are testing on localhost
// const URL_PATH = `${PROTOCOL}://${HOSTNAME}:${PORT}`
export default URL_PATH
